import { Box, styled } from '@mui/material'

export const ActionBarContainer = styled(Box)(() => ({
    display: 'flex',
    justifyContent: 'flex-start',
    width: '100%',
    gap: '10px',
    flexDirection: 'row',
}))
